import { LogOut, Monitor } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function MobileReadOnlyState({ onLogout }) {
  return <main className="monitor-readonly-state"><span className="monitor-brand"><span className="brand-symbol">S</span><strong>SU-Guide Admin</strong></span><Monitor size={30} /><h1>PC에서 관리해주세요</h1><p>모바일에서는 데이터 조회만 지원합니다.</p><p>수정 및 운영 작업은 PC 관리자 콘솔에서 진행할 수 있습니다.</p><Link className="button primary" to="/dashboard">오늘 보기</Link>{onLogout && <button className="button ghost" type="button" onClick={onLogout}><LogOut size={15} /> 로그아웃</button>}</main>
}
